import ActionTypes from './types';
import store from './../store/configureStore';
import {makeSignedRequest} from './../utils';
import {holdSpotURL, cancelHoldSpotURL, unreserveSpotURL, reserveSpotURL, tradeSpotURL} from '../utils/restUrls';
import { statusChannelName } from './../utils/pusher';
import { CHECKOUT_EVENTS } from './../constants';

export const updateSpotToRemove = (spotName) => {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.UPDATE_CHECKOUT_SPOT_TO_REMOVE,
      spotToUnreserve: spotName
    });
  };
};

export const startTradeSpot = (spotToReserve, spotToUnreserve) => {
  return (dispatch) => {
    afterCheckoutButtonClick(dispatch, CHECKOUT_EVENTS.trade, {
      spotToReserve: spotToReserve,
      spotToUnreserve: spotToUnreserve,
    });
  };
};

export const checkoutUnreserveSpot = (spotName) => {
  return (dispatch) => {
    afterCheckoutButtonClick(dispatch, CHECKOUT_EVENTS.unreserve, {
      spotToUnreserve: spotName,
    });
  };
};

export const cancelCheckout = () => {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.RESET_CHECKOUT_DATA
    });

    dispatch({
      type: ActionTypes.SET_NAV_CHECKOUT_STATE,
      isCheckoutPageOpened: false
    });
  };
};

export const confirmCheckout = () => {
  const {spotToReserve} = store.getState().checkout;
  return (dispatch) => {
    dispatch({
      type: ActionTypes.SET_CHECKOUT_LOADER
    });

    makeSignedRequest(reserveSpotURL(spotToReserve), 'PUT', {status: 'RESERVE'}, getAjaxHeaders())
      .then((body) => {
        if(body.error) {
          dispatch({ type: ActionTypes.RESET_CHECKOUT_LOADER });
        } else {
          dispatch(afterCheckoutButtonRequest(body.requestID, CHECKOUT_EVENTS.reserve));
        }
      });
  };
};

export const confirmTradeSpot = () => {
  const {spotToReserve, spotToUnreserve} = store.getState().checkout;
  return (dispatch) => {
    dispatch({
      type: ActionTypes.SET_CHECKOUT_LOADER
    });

    const apiEndPoint = tradeSpotURL();
    const data = {fromSpotIdentifier: spotToUnreserve, toSpotIdentifier: spotToReserve};

    makeSignedRequest(apiEndPoint, 'POST', data, getAjaxHeaders())
      .then((body) => {
        if(body.error) {
          dispatch({ type: ActionTypes.RESET_CHECKOUT_LOADER });
        } else {
          dispatch(afterCheckoutButtonRequest(body.requestID, CHECKOUT_EVENTS.trade));
        }
      });
  };
};


export const checkoutHoldSpot = (spotToHold) => {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.SET_CHECKOUT_LOADER
    });

    makeSignedRequest(holdSpotURL(spotToHold), 'PUT', {status: 'HOLD'}, getAjaxHeaders())
      .then((body) => {
        if(body.error) {
          dispatch({ type: ActionTypes.RESET_CHECKOUT_LOADER });
        } else {
          dispatch({
            type: ActionTypes.SET_NAV_CHECKOUT_STATE,
            isCheckoutPageOpened: true
          });
          dispatch(afterCheckoutButtonRequest(body.requestID, CHECKOUT_EVENTS.hold, {
            spotToReserve: spotToHold
          }));
        }
      });
  };
};

export const cancelHoldSpot = (spotToReserve) => {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.SET_CHECKOUT_LOADER
    });

    makeSignedRequest(cancelHoldSpotURL(spotToReserve), 'DELETE', {}, getAjaxHeaders())
      .then((body) => {
        if(body.error) {
          dispatch({ type: ActionTypes.RESET_CHECKOUT_LOADER });
        } else {
          dispatch(afterCheckoutButtonRequest(body.requestID, CHECKOUT_EVENTS.cancelHold));
        }
      });
  };
};

export const confirmUnreserve = (spotToUnreserve) => {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.SET_CHECKOUT_LOADER
    });

    makeSignedRequest(unreserveSpotURL(spotToUnreserve), 'DELETE', {}, getAjaxHeaders())
      .then((body) => {
        if(body.error) {
          dispatch({ type: ActionTypes.RESET_CHECKOUT_LOADER });
        } else {
          dispatch(afterCheckoutButtonRequest(body.requestID, CHECKOUT_EVENTS.unreserve));
        }
      });
  };
};

export const setTimeStamp = (timeStamp) => {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.UPDATE_TIMESTAMP,
      timeStamp: timeStamp
    });
  };
};

const getAjaxHeaders = () => {
  return {
    'x-websocket': statusChannelName()
  };
};

const afterCheckoutButtonClick = (dispatch, event, obj) => {
  dispatch({
    type: ActionTypes.SET_NAV_CHECKOUT_STATE,
    isCheckoutPageOpened: true
  });

  setCheckoutData(dispatch, event, obj);
};

const setCheckoutData = (dispatch, event, obj) => {
  dispatch({
    type: ActionTypes.SET_CHECKOUT_EVENT,
    event,
  });

  if(obj){
    dispatch({
      type: ActionTypes.SET_CHECKOUT_DATA,
      ...obj,
    });
  }
};

const afterCheckoutButtonRequest = (requestID, event, obj) => {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.SET_REQUEST_ID,
      requestId: requestID,
    });
    dispatch({
      type: ActionTypes.TOGGLE_BACKEND_RELASE_SPOT_FLAG,
      isBackendRelasedSpot: null
    });

    setCheckoutData(dispatch, event, obj);
  };
};

export const afterCheckoutCloseButtonClick = () => {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.TOGGLE_BACKEND_RELASE_SPOT_FLAG,
      isBackendRelasedSpot: null
    });

    dispatch(cancelCheckout());
  };
};

export const setCheckoutDetailsIfSpotsHeld = () => {
  const { heldSpot } = store.getState().userAccommodationInfo;

  if(heldSpot) {
    return (dispatch) => {
      dispatch({
        type: ActionTypes.SET_CHECKOUT_DATA,
        spotToReserve: heldSpot,
      });

      dispatch({
        type: ActionTypes.RESET_CHECKOUT_LOADER,
      });

      dispatch({
        type: ActionTypes.SET_CHECKOUT_EVENT,
        event: CHECKOUT_EVENTS.hold
      });

      dispatch({
        type: ActionTypes.SET_NAV_CHECKOUT_STATE,
        isCheckoutPageOpened: true
      });
    };
  }

  return (dispatch) => {
    dispatch({
      type: ActionTypes.SET_NAV_CHECKOUT_STATE,
      isCheckoutPageOpened: false
    });
  };
};



// WEBPACK FOOTER //
// ./src/actions/checkout.js